export default __webpack_public_path__ + "static/media/Google.ae758f38.svg";